export default function calculateTimeRemaining(secondsRemaining) {
  if (!secondsRemaining || secondsRemaining <= 0) {
    return undefined;
  }

  // platform returns 1 second short (eg, 299 for 5 minutes) - fix this
  const adjustedSecondsRemaining = Math.ceil(secondsRemaining / 60) * 60;

  const ret = {};
  if (adjustedSecondsRemaining > 0 && adjustedSecondsRemaining < 3600) {
    // 0 - 60 minutes
    ret.value = Math.floor(adjustedSecondsRemaining / 60);
    ret.unit = 'minutes';
  } else if (
    adjustedSecondsRemaining >= 3600 &&
    adjustedSecondsRemaining < 86400
  ) {
    // 1 - 24 hours
    ret.value = Math.floor(adjustedSecondsRemaining / 3600);
    ret.unit = 'hours';
  } else {
    // 1+ days
    ret.value = Math.floor(adjustedSecondsRemaining / 86400);
    ret.unit = 'days';
  }

  return ret;
}
